// Builds wa.me direct-message URLs with a properly URL-encoded pre-filled
// message. Centralised here so every link the site renders has consistent
// copy and we only need to change a message in one place.

const PHONE = '+917310777189';

export const WA_MESSAGES = {
  liveClasses:
    'Hi, I am interested in joining the live meditation classes. ' +
    'Could you share more details about timings and batches?',
  query:
    'Hi, I have a question about MyShaktiverse. Could you help me?',
};

export const whatsappUrl = (message) =>
  `https://wa.me/${PHONE}?text=${encodeURIComponent(message)}`;

// Pre-built URLs for the two common contexts the site uses.
export const WA_LIVE_CLASSES_URL = whatsappUrl(WA_MESSAGES.liveClasses);
export const WA_QUERY_URL = whatsappUrl(WA_MESSAGES.query);

// Direct dial (floating contact button).
export const WA_DIRECT_URL = `https://wa.me/917310777189`;

// Context-specific enquiry links with the exact pre-filled Namaste copy
// used across the announcement strip, live-class cards and healing cards.
export const WA_LIVE_ENQUIRE_URL =
  'https://wa.me/917310777189?text=Namaste%20Sanjay%20Ji%2C%20I%20am%20interested%20in%20joining%20the%20live%20Siddha%20Kriya%20classes.%20Could%20you%20please%20share%20details%20about%20the%20timings%20and%20batches%3F';
export const WA_HEALING_ENQUIRE_URL =
  'https://wa.me/917310777189?text=Namaste%20Sanjay%20Ji%2C%20I%20would%20like%20to%20book%20a%20Siddha%20healing%20session.%20Could%20you%20please%20share%20your%20availability%20and%20details%3F';

// Builds an auth URL that, after successful login / signup / email
// verification, sends the user back to wherever they were standing.
//
// Pass the current `useLocation()` value. If you want a custom next path
// (e.g. send the user to /enroll/level-1 instead of the current page),
// pass it explicitly as `nextPath`.
export const authUrlWithNext = (location, nextPath) => {
  const target =
    nextPath ||
    (location ? `${location.pathname}${location.search || ''}` : '/dashboard');
  // Never include /auth itself as a next-target; that would loop.
  if (!target || target.startsWith('/auth')) return '/auth';
  return `/auth?next=${encodeURIComponent(target)}`;
};
